import { IOrder } from './order.model';

export function mapOrderItem(data: any) {
    return {
        ...(data || {}),
        orderCode: data?.externalContext?.order_code || data?.externalContext?.order_reference_id,
    } as IOrder;
}

export function mapOrders(data: any[]) {
    if (!data) {
        return [];
    }

    return data.map(mapOrderItem);
}
